module.exports = __webpack_public_path__ + "app/docrepo-invoice/detail/detail-2NPkuLgc.html";